<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
            <div class="row mb-3 mr-0 pr-0 d-flex justify-content-end">
              <div class="col-auto pr-0">
                <CButton color="success" @click="createRole()">{{ $t('button.create') }} {{ $tc('roles.label', 1) }}</CButton>
              </div>
            </div>
            <CDataTable
              :items="filteredItems"
              :fields="fields"
              :items-per-page="perPage"
              :itemsPerPageSelect="itemsPerPage"
              :tableFilter="tableFilter"
              :table-filter-value.sync="search"
              :loading="loading"
              addTableClasses="d-print-table table-dropdown-fix"
              hover
              sorter
              pagination
            >
              <template #options="{item}">
                <td>
                  <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle" @click="openOptions" type="button" data-toggle="dropdown">
                      {{ $t('button.options') }}
                    </button>
                    <div class="dropdown-menu">
                      <button class="dropdown-item" type="button" @click="showRole(item.id)">{{ $t('button.details') }}</button>
                      <button class="dropdown-item" type="button" @click="editRole(item.id)">{{ $t('button.edit') }}</button>
                      <button class="dropdown-item" type="button" @click="deleteRole(item.id)">{{ $t('button.delete') }}</button>
                    </div>
                  </div>
                </td>
              </template>
            </CDataTable>
        </CCardBody>  
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import listMixin from '../../mixins/list';
import i18n from "../../i18n";
import localeMixin from '../../mixins/locale';

export default {
  name: 'Roles',
  mixins: [listMixin, localeMixin],
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'name',
          label: i18n.t('fields.name')
        }, 
        {
          key: 'options',
          label: i18n.t('button.options'),
          sorter: false,
          filter: false
        }
      ],
      tableFilter: {
        label: i18n.t('search'),
        placeholder: i18n.t('roles.search_placeholder'),
        lazy: false,
        external: true
      },
    }
  },
  computed: {
    filteredItems() {
      return this.items.filter(i => {
        return i.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  mounted() {
    this.getRoles();
  },
  methods: {
    showRole (id) {
      this.$router.push({ name: 'Role', params: {id} });
    },
    editRole (id) {
      this.$router.push({ name: 'EditRole', params: {id} });
    },
    deleteRole (id) {
      // let self = this;
      // let noteId = id;
      // axios.post(  '/api/roles/' + id + '?token=' + localStorage.getItem("api_token"), {
      //   _method: 'DELETE'
      // })
      // .then(function (response) {
      //   if(response.data.status === 'success'){
      //       self.message = 'Successfully deleted role.';
      //       self.showAlert();
      //       self.getRoles();
      //   }else if(response.data.status === 'rejected'){
      //       self.message = "Can't delete. Role has assigned one or more menu elements.";
      //       self.showAlert();
      //   }
      // }).catch(function (error) {
      //   console.log(error);
      //   self.$router.push({ path: '/login' });
      // });
      this.$swal({
        title: i18n.t('roles.modal.delete_label'),
        html: i18n.t('roles.modal.delete_body'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('button.accept')
      }).then(result => {
        if (result.value) {
          // do delete request
          axios.delete('/api/roles/'+ id + '?token=' + localStorage.getItem("api_token"))
          .then(response => {
            this.$swal(
              i18n.t('roles.modal.deleted_label'),
              i18n.t('roles.modal.deleted_body'),
              'success'
              );
              this.getRoles();
          });
        }
      });
    },
    moveUp( id ){
      let self = this;
      axios.get(  '/api/roles/move/move-up?id=' + id + '&token=' + localStorage.getItem("api_token"))
      .then(function (response) {
          self.message = 'Successfully move role.';
          self.showAlert();
          self.getRoles();
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    },
    moveDown( id ){
      let self = this;
      axios.get(  '/api/roles/move/move-down?id=' + id + '&token=' + localStorage.getItem("api_token"))
      .then(function (response) {
          self.message = 'Successfully move role.';
          self.showAlert();
          self.getRoles();
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    },
    createRole () {
      this.$router.push({ name: 'CreateRole'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    getRoles() {
      this.loading = true;
      axios.get('/api/roles?token=' + localStorage.getItem("api_token") )
      .then(response => {
        this.items = response.data;
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        console.log(error);
        this.$router.push({ path: '/login' });
      });
    }
  }
}
</script>

